import {
  AlignItems,
  Box,
  Color,
  Display,
  FlexDirection,
  JustifyContent,
  ResponsiveValue,
  withCitrusTheme,
  Space,
  Button,
  ButtonColorVariant,
} from '@gousto-internal/citrus-react'
import React from 'react'
import { CSSObject } from '@emotion/react'
import desktopPattern from '../../assets/OurSuppliersSectionAssets/large-pattern.svg'
import mobilePattern from '../../assets/OurSuppliersSectionAssets/mobile-pattern.svg'
import { SupplierCarousel } from './components/SupplierCarousel/SupplierCarousel'
import { SupplierContent } from './components/SupplierContent'
import { LandingPageContentSections, TrackingActions, trackCTAClick } from '../../tracking'
import { OUR_SUPPLIERS_COPY } from '../../config'

const responsiveBackground: ResponsiveValue<string> = [
  `80% 0 / cover no-repeat url(${desktopPattern})`,
  `80% 0 / cover no-repeat url(${mobilePattern})`,
  `100% 0 / contain no-repeat url(${desktopPattern})`,
  `60% top / contain no-repeat url(${desktopPattern})`,
  `60% top / contain no-repeat url(${desktopPattern})`,
]

const SectionWithBackground = withCitrusTheme(Box, (theme) => ({
  ...(theme.responsiveStyle(responsiveBackground, ['background']) as CSSObject),
}))

export const OurSuppliersSection = () => {
  const trackClickSuppliers = () => {
    trackCTAClick(TrackingActions.OUR_SUPPLIERS, LandingPageContentSections.OUR_SUPPLIERS)
    window.location.assign(OUR_SUPPLIERS_COPY.ourSuppliersURL)
  }

  return (
    <section data-testid="ourSuppliersSection">
      <Box bg={Color.ColdGrey_800}>
        <SectionWithBackground
          display={Display.Flex}
          flexDirection={[FlexDirection.Column, null, null, FlexDirection.Row]}
          paddingV={[12, null, null, 0]}
        >
          <Box
            display={Display.Flex}
            paddingV={[4, null, null, 8]}
            paddingH={8}
            justifyContent={[JustifyContent.FlexStart, null, null, JustifyContent.Center]}
            alignItems={[AlignItems.FlexStart, null, null, AlignItems.Center]}
            width={['100%', null, null, '50%']}
          >
            <Space direction="horizontal" size={[null, null, null, 8, 20]} />
            <SupplierContent onClick={trackClickSuppliers} />
          </Box>
          <Box
            display={Display.Flex}
            flexDirection={FlexDirection.Column}
            paddingV={[4, null, null, 8]}
            justifyContent={JustifyContent.Center}
            alignItems={[AlignItems.FlexStart, AlignItems.Center, null]}
            width={['100%', null, null, '50%']}
          >
            <SupplierCarousel />
            <Box width="100%" paddingH={8} display={[Display.Block, Display.None]}>
              <Space size={10} />
              <Button
                onClick={trackClickSuppliers}
                height="48px"
                width="100%"
                colorVariant={ButtonColorVariant.Secondary}
              >
                {OUR_SUPPLIERS_COPY.ctaLabel}
              </Button>
            </Box>
          </Box>
        </SectionWithBackground>
      </Box>
    </section>
  )
}
